import { render, staticRenderFns } from "./GaSelect.vue?vue&type=template&id=161657c7&scoped=true&"
import script from "./GaSelect.vue?vue&type=script&lang=ts&"
export * from "./GaSelect.vue?vue&type=script&lang=ts&"
import style0 from "./GaSelect.vue?vue&type=style&index=0&id=161657c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161657c7",
  null
  
)

export default component.exports